import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { type FC } from "react";

import type { FollowUpMomentDetails } from "../../../follow-up/server/types";
import { FollowUpMomentsTable } from "../follow-up/follow-up-moments-table";

export const FollowUpsPublishDialog: FC<{
  open: boolean;
  onClose: () => void;
  followUpData: FollowUpMomentDetails;
}> = ({ open, onClose, followUpData }) => {
  const existing_follow_ups = followUpData.existing_follow_ups || [];

  if (existing_follow_ups.length === 0) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Don’t forget to review your Follow-Ups</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            This communication has {existing_follow_ups.length} Follow-Ups associated with it. As
            you’ve made a changes, you might want to review them.
          </Typography>
          <FollowUpMomentsTable
            followUpDataLoader={{
              loading: false,
              error: null,
              data: followUpData,
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          data-analytics-id="moment-form-follow-ups-publish-dialog-close-button"
          variant="text"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
